import { Button, Flex } from 'antd';
import { useAppSelector } from 'utilities/hooks';

export const ActionSharingCancelSave = ({ close, handleSave }: { close: () => void; handleSave: () => void }) => {
    const { loading: teamLoading } = useAppSelector((state) => state.team);
    const { loading: invitationsLoading } = useAppSelector((state) => state.invitations);

    return (
        <Flex style={{ marginLeft: 'auto' }}>
            <Button type="text" onClick={close}>
                Cancel
            </Button>
            <Button type="primary" onClick={handleSave} loading={teamLoading || invitationsLoading}>
                Save
            </Button>
        </Flex>
    );
};
